import { render, staticRenderFns } from "./SurveySection.vue?vue&type=template&id=02d498ca&scoped=true&"
import script from "./SurveySection.vue?vue&type=script&lang=js&"
export * from "./SurveySection.vue?vue&type=script&lang=js&"
import style0 from "./SurveySection.vue?vue&type=style&index=0&id=02d498ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d498ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
